import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthStateService } from 'app/core/services/auth-state.service';
import { FileManagerService } from 'app/core/services/file-manager.service';
import { DeviceService } from 'app/core/services/device.service';
import { AgresSpinnerCanvasService } from 'app/shared/components/agres-spinner-canvas/agres-spinner-canvas.service';
import { UserFilesManager } from 'app/utils/user-files-manager';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
@Component({
  standalone: false,
  selector: 'app-send-field-files',
  templateUrl: './send-field-files.component.html',
  styleUrls: ['./send-field-files.component.scss'],
})
export class SendFieldFilesComponent implements OnInit {
  @Input() fileName: string;
  @Input() offCanvasDevices = new Subject<boolean>();
  @Input() filesToAssociate: Array<string>;
  @Input() fieldKey: string;
  private readonly authState = inject(AuthStateService);

  deviceSelected: string;
  devices: Array<string>;
  userLogged: string;

  private cloudantManager: UserFilesManager;

  constructor(
    private readonly deviceService: DeviceService,
    public fileManagerService: FileManagerService,
    public translateService: TranslateService,
    private readonly toastr: ToastrService,
    public loadingAgresSpinnerCanvas: AgresSpinnerCanvasService,
    public httpClient: HttpClient,
  ) {
    this.cloudantManager = new UserFilesManager(fileManagerService, httpClient);
  }

  ngOnInit() {
    this.userLogged = this.authState.getUser()?.id;
    this.translateService.get('global.loading.map-wait').subscribe((res) => {
      this.loadingAgresSpinnerCanvas.toShow(res);
    });
    this.getDevices();
  }

  sendFiles() {
    const filesWithFieldId = this.filesToAssociate.map(
      (fileName) => `${this.fieldKey}/${fileName}`,
    );
    this.cloudantManager
      .saveData(
        this.userLogged,
        filesWithFieldId,
        'devices',
        this.deviceSelected,
      )
      .subscribe(
        () => {
          this.feedBackToUser('global.alert.send-success', 'success');
          this.offCanvasDevices.next(false);
        },
        (error) => {
          this.feedBackToUser(error, 'error');
        },
      );
  }

  private feedBackToUser(message: string, type: string) {
    this.translateService.get(message).subscribe((res: string) => {
      switch (type) {
        case 'success':
          this.toastr.success(res, '', {
            positionClass: 'toast-top-full-width',
            disableTimeOut: false,
          });
          break;
        case 'error':
          this.toastr.error(res, '', {
            positionClass: 'toast-top-full-width',
            disableTimeOut: false,
          });
          break;
        case 'info':
          this.toastr.info(res, '', {
            positionClass: 'toast-top-full-width',
            disableTimeOut: false,
          });
          break;
        default:
          this.toastr.info(res, '', {
            positionClass: 'toast-top-full-width',
            disableTimeOut: false,
          });
          break;
      }
    });
  }

  onDeviceChange(event): void {
    this.deviceSelected = event.target.value;
  }
  async getDevices() {
    this.devices = await this.getAllDevices();
    this.loadingAgresSpinnerCanvas.toHide();
  }
  private getAllDevices() {
    return this.deviceService.getAllDeviceRealtime().toPromise();
  }
}
